import client from "./client";

export interface VersionResponse {
  version: string;
}

export const getAppVersion = () => client.get<VersionResponse>("/version").then(({ data }) => data);
